import { Navigate, useLocation } from "react-router-dom";
import { Loader2, ShieldOff } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const Spinner = () => (
  <div className="grid min-h-[50vh] place-items-center" data-testid="page-loading">
    <Loader2 className="h-8 w-8 animate-spin" />
  </div>
);

export const ProtectedRoute = ({ admin = false, children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <Spinner />;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  if (admin && !user.is_admin) {
    return (
      <div data-testid="admin-forbidden" className="mx-auto max-w-md px-4 py-24 text-center">
        <ShieldOff className="mx-auto h-10 w-10" />
        <h1 className="mt-4 text-2xl font-extrabold">Area riservata</h1>
        <p className="mt-2 text-sm text-muted-foreground">Questa sezione è solo per gli admin del negozio.</p>
      </div>
    );
  }
  return children;
};
